// Dependency
import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, { Navigation, Mousewheel } from 'swiper';

// Assets
import upsellIcon from '../assets/upsell.svg'

// Components
import UpsellCard from "./upsell-card";

// Internationalization
import { useTranslation } from 'react-i18next';

// Styles
import * as styles from './upsell.module.scss';

// install Swiper modules
SwiperCore.use([Navigation, Mousewheel]);

// Template
const Upsell = (props) => {

    // Translation Function
    const { t } = useTranslation();

    return (
        <div className={`${styles.cdUpsellWrapper} cd-swiper-wrapper`}>
            <div className={styles.cdUpsellHeading}>
                <h4>{t('miniCart.compatible')}</h4>
            </div>
            <Swiper className={`${styles.cdUpsellSwiper}`}
                    direction={'horizontal'}
                    spaceBetween={16}
                    slidesPerView={3}
                    grabCursor={true}
                    forceToAxis={true}
                    mousewheel={{
                        forceToAxis: true
                    }}
                    breakpoints={{
                        900:{
                            spaceBetween: 16,
                            slidesPerView: 3,
                            slidesPerGroup: 1
                        },
                        0:{
                            spaceBetween: 10,
                            slidesPerView: 3,
                            slidesPerGroup: 1
                        }
                    }}
            >
                {props.upsell.map((product, i) => {
                    return (
                        <SwiperSlide key={i} className={``}>
                            <UpsellCard country={props.country} prodId={product.id} product={product} />
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    );
};

export default Upsell;